/**
 * Hard-coded fallback list of enterprise-customer email domains.
 *
 * The primary mechanism is the data-driven `skipNewUserSurvey` flag — a verified domain claim of
 * an Enterprise-tier company, computed server-side in `captureSignInData`. This list is an
 * additive, client-side shim for enterprise customers not yet covered by that (e.g. they haven't
 * set up a verified domain claim): add a domain here to immediately skip the forced onboarding
 * survey and the sales calendar for that company — no backend deploy or data setup required.
 *
 * To shim a customer in quickly, add their email domain (lowercase, no `@`) below.
 */
export const FALLBACK_ENTERPRISE_EMAIL_DOMAINS: string[] = [
	'gensler.com',
	'perkinseastman.com',
	'woodsbagot.com',
];

export function emailMatchesFallbackEnterpriseDomain (email: string): boolean {
	const normalizedEmail: string = (email ?? '').trim().toLowerCase();
	if (!normalizedEmail) {
		return false;
	}
	return FALLBACK_ENTERPRISE_EMAIL_DOMAINS.some((domain: string) => normalizedEmail.endsWith(`@${domain}`));
}
